

export default function FullDivider(){

    return (
        <div
            className="
                h-px
                bg-home-text-grey/30
                my-7
                w-full
            "
        />

    );

}